// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"icon-with-badge_iconWrapper__xZawy","badge":"icon-with-badge_badge__kIsrC"};